
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke133aRequest, Sgke133aResponse, Sgke133aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke133aService {

  /**
   * コンストラクタ
   * @param {Sgke133aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke133aService
   */
  constructor(
    public service: Sgke133aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE133A_入金突合明細承認API呼び出し
   * @param {Sgke133aRequest} request 
   * @returns {Observable<Sgke133aResponse>}
   * @memberof UsedSgke133aService
   */
  public doSgke133a(request: Sgke133aRequest): Observable<Sgke133aResponse> {
    return this.service.sgke133aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE133A');
          return throwError(err.message);
        })
      );
  }

}
